import React, {useRef, useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import Form, {FormInputComponent} from "../../../components/form/Form";

const MAX_GALLERY_ASSETS_COUNT = 20

const SupplierWorkGalleryStep = ({supplierOrg, isDisabled, isUpdating, onChange, onSave,...props}) => {

    const {auth} = useAuth()

    const formRef = useRef(null);
    const [formModel, setFormModel] = useState({assets: auth?.supplierOrg()?.assets || []})
    const handleAssetsChange = (newAssets) => {
        console.log('handleAssetsChange', newAssets)
        onChange({assets: newAssets});
    }
    const FormClass = 'talent-role-form add-talent-form '
    const checkFileType = (file) => {
        const isImageMime = file.type && file.type.startsWith('image/')
        const isVideoMime = file.type && file.type.startsWith('video/')
        const isImageExt = /\.(jpg|jpeg|png|gif|webp)$/i.test(file.path)
        const isVideoExt = /\.(mp4|webm|mov|avi|wmv)$/i.test(file.path)

        return {
            isImage: isImageMime || isImageExt || file.content_type ==='Image',
            isVideo: isVideoMime || isVideoExt || file.content_type ==='Video'
        }
    }
    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Work Gallery
                            </h3>
                        </div>

                        <h5 className="form-subtitle">
                            {/* Showcase your agency's best work. Upload multiple images and videos to your work gallery to give clients a comprehensive view of your capabilities. You can hover over each asset after selecting it to update the caption. */}
                            Showcase your agency's best work.  Upload images and videos that highlight your capabilities. Add multiple assets to give clients a complete view of your expertise. After uploading, hover over any item to edit its caption.
                        </h5>
                    </div>
                </div>
            </div>
            <div className={TB.mapClass(FormClass, {
                'active-edit': !isUpdating,
                'inactive-edit': isUpdating
            })}>

                <Form
                    ref={formRef}
                    title={false}
                    subtitle={null}
                    showRequired
                    submitButton={false}
                    onChange={(itemProps) => {
                        if (isUpdating) return;
                        let updates = {...formModel}
                        for (let [key, value] of Object.entries(itemProps)) {
                            updates = TB.set(updates, key, value)
                        }

                        if (onChange) {
                            updates = onChange(updates)
                        }
                        setFormModel(updates)
                    }}
                    model={formModel}
                    fields={[]}
                    isDisabled={isUpdating}>

                    <div className="field-section flex-row">
                        <div className="field px-3.5 basis-10/12">
                            <div className="form-group">
                                <FormInputComponent
                                    fieldName="assets"
                                    value={supplierOrg?.assets || []}
                                    // className="[&_.ant-upload-list-picture-card-container]:w-40 [&_.ant-upload-list-picture-card-container]:h-40 [&_.ant-upload-select-picture-card]:w-40 [&_.ant-upload-select-picture-card]:h-40"
                                    label="Work Gallery Assets"
                                    type="multi-image"
                                    display_label="Gallery Asset"
                                    accept=".jpg,.jpeg,.png,.gif,.mp4,.webm,.mov"
                                    maxCount={MAX_GALLERY_ASSETS_COUNT}
                                    required={false}
                                    maxSize={40 * 1024 * 1024} // 40mb
                                    onChange={handleAssetsChange}
                                    // itemRender={(node, file, filelist, actions) => {
                                    //     console.log('HEREEEE!', file);
                                    //     return (
                                    //         <div
                                    //             className="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                                    //             <div className="absolute inset-0 flex flex-col items-center">
                                    //                 {checkFileType(file)?.isImage ? (
                                    //                     <img
                                    //                         src={file.path}
                                    //                         alt={file.content_type}
                                    //                         className={TB.mapClass("w-full h-full object-cover pointer-events-none transition-transform group-hover:scale-105")}
                                    //                     />
                                    //                 ) : (
                                    //                     <video
                                    //                         className={TB.mapClass("w-full h-full object-cover pointer-events-none transition-transform group-hover:scale-105")}
                                    //                         controls={false} muted src={file.path} />
                                    //                 )}
                                    //             </div>
                                    //             <div className="ant-upload-list-item-info">
                                    //                 <span className="ant-upload-span">
                                    //                     <a
                                    //                         className="ant-upload-list-item-thumbnail ant-upload-list-item-file"
                                    //
                                    //                         target="_blank" rel="noopener noreferrer">
                                    //                         <i className="fa-white fas fa-play-circle"/>
                                    //                     </a>
                                    //                     {file?.name}
                                    //                 </span>
                                    //             </div>
                                    //             <span className="ant-upload-list-item-actions">
                                    //                 <button
                                    //
                                    //                 onClick={actions.onPreview} rel="noopener noreferrer" title="Preview file">
                                    //                 <i className="fas fa-white fa-eye"/>
                                    //             </button>
                                    //                 <button title="Remove file" type="button"
                                    //                         className="ant-btn ant-btn-text ant-btn-sm ant-btn-icon-only ant-upload-list-item-card-actions-btn">
                                    //                     <i className="fa-white fas fa-trash"/>
                                    //                 </button>
                                    //             </span>
                                    //         </div>
                                    //     )
                                    // }}
                                />
                            </div>
                        </div>
                    </div>
                </Form>

            </div>
        </div>
    )
}

export default SupplierWorkGalleryStep